export default function yahooTrackLead() {
    window.dotq = window.dotq || [];
    window.dotq.push(
        {
            'projectId': '10000',
            'properties': {
                'pixelId': '10023607',
                'qstrings': {
                    'et': 'custom',
                    'ec': 'leadsubmission',
                }
            }
        })
}